<p-blockui [blocked]="isLoading">
  <p-progress-spinner></p-progress-spinner>
</p-blockui>

<div class="flex flex-col gap-6 pb-[10rem]">
  <div class="flex flex-row justify-between">
    <div class="">
      <h1 class="main-title">Formularios</h1>
    </div>
  </div>

  <!-- Sección de filtros -->
  <app-form-filter #formFilter [loading]="isLoading" [disableDownload]="isDownloadDisabled"
    [isDownloading]="isDownloadingExcel" [emissionSourceHierarchy]="emissionSourceHierarchy"
    [globalWarmingPotential]="globalWarmingPotentialOptions" [mode]="mode" (search)="onSearch($event)"
    (addNewActivity)="onAddActivity()" (gwpChange)="onGwpChange($event)" (download)="onDownloadExcel()"
    (downloadTemplate)="onDownloadTemplate()" (uploadExcel)="onUploadExcelTemplate($event)" />

  @if (mode === 'manual') {
  <app-form-builder #formBuilder [formula]="formula" [activities]="activities" [filters]="filters" [loading]="isLoading"
    [emissionFactorOptions]="emissionFactorOptions" [globalWarmingPotentialOptions]="globalWarmingPotentialOptions"
    [conversionOptions]="conversionOptions" (tableDataChange)="onTableDataChange($event)"
    (openUploadFilesDialog)="onOpenUploadFilesDialog($event)" (deleteActivity)="onDeleteActivity($event)" />
  }

  @if (mode === 'excel') {
  <div
    class="mt-8 mb-8 border-2 border-dashed border-gray-200 rounded-xl bg-white flex flex-col items-center justify-center py-16 px-8 min-h-[320px]">

    @if (templateStatus === 'success' && !excelFile) {
    <div class="bg-purple-100 rounded-full w-15 h-15 mb-5 flex justify-center items-center">
      <span class="material-symbols-rounded text-purple-800" style="font-size: 32px;">description</span>
    </div>
    <h3 class="text-gray-800 font-semibold text-lg mb-2">
      Carga masiva requerida
    </h3>
    <p class="text-gray-400 text-sm text-center max-w-xs leading-relaxed">
      Esta fuente de emisión requiere carga masiva vía Excel.
      Descargue la plantilla, complete la información y cárguela nuevamente.
    </p>
    }

    @if (templateStatus === 'success' && excelFile) {
    <div class="bg-green-100 rounded-full w-15 h-15 mb-5 flex justify-center items-center">
      <i class="pi pi-file-excel text-green-600" style="font-size: 32px;"></i>
    </div>
    <h3 class="text-gray-800 font-semibold text-lg mb-2">
      {{ excelFile.name }}
    </h3>
    <p class="text-gray-400 text-sm text-center max-w-xs leading-relaxed">
      Se ha cargado un archivo Excel, utilice el botón <strong>Guardar</strong> para almacenar la información.
    </p>
    }

    @if (templateStatus === 'not-found') {
    <div class="bg-yellow-100 rounded-full p-5 mb-5">
      <i class="pi pi-exclamation-triangle text-4xl text-yellow-600"></i>
    </div>
    <h3 class="text-gray-800 font-semibold text-lg mb-2">
      Plantilla no encontrada
    </h3>
    }

    @if (templateStatus === 'error') {
    <div class="bg-red-100 rounded-full p-5 mb-5">
      <i class="pi pi-times-circle text-4xl text-red-600"></i>
    </div>
    <h3 class="text-gray-800 font-semibold text-lg mb-2 text-center">
      Hubo un error en el proceso. Por favor repórtelo al administrador.
    </h3>
    }

  </div>
  }

  <!-- Footer solo disponible al agregar/editar una actividad -->
  @if (hasNewActivity) {
  <app-form-footer>
    <div class="flex flex-row justify-end gap-2 w-full">
      <p-button fluid label="Guardar" (onClick)="mode === 'excel' ? onSaveExcel() : onSave()" class="w-30"
        [loading]="isLoading"></p-button>
    </div>
  </app-form-footer>
  }

  <p-dialog [(visible)]="visibleUploadFilesDialog" [modal]="true" [style]="{ width: '50rem' }" header="Anexos"
    maskStyleClass="backdrop-blur-sm" (visibleChange)="onCloseUploadFiles()" (onHide)="resetFileUpload()">
    <div class="flex flex-col gap-6 p-6 pt-2">
      <p class="text-center font-semibold">Suba aquí sus anexos</p>

      <p-fileupload #fileUpload accept=".xlsx, .pdf, .jpg, .png" maxFileSize="10485760" [fileLimit]="10"
        chooseLabel="Seleccionar" [multiple]="true" [previewWidth]="0" (onSelect)="onSelectFile($event)"
        [showUploadButton]="false" [showCancelButton]="false" class="hide-img-fileupload">
        <ng-template #empty>
          @if (!validFiles.length && !uploadedFiles.length) {
          <div class="flex flex-col items-center gap-4 w-full pb-8">
            <span class="material-symbols-outlined text-black add-photo-icon">
              add_photo_alternate
            </span>
            <span class="font-bold w-60 text-center text-black">
              Arrasta tus archivos aquí o da clic en el botón seleccionar
            </span>
          </div>
          }
        </ng-template>
        <ng-template pTemplate="content" let-files>
          @if (validFiles.length || uploadedFiles.length) {
          <div class="flex flex-col w-full h-30 2xl:h-70 overflow-y-auto">
            <!-- Archivos nuevos -->
            @for (item of validFiles; track $index) {
            <div class="flex flex-row justify-between content-center">
              <p-button link class="pl-4 truncate" (onClick)="downloadNewFile(item)">
                {{ item.name }}
              </p-button>

              <p-button variant="text" severity="danger" icon="pi pi-times" class="custom-button"
                (onClick)="removeFile(item)">
              </p-button>
            </div>
            }
            <!-- Archivos antiguos -->
            @for (item of uploadedFiles; track $index) {
            <div class="flex flex-row justify-between content-center">
              <p-button link class="pl-4 truncate" (onClick)="downloadExistingFile(item)">
                {{ item.Name }}
              </p-button>
            </div>
            }
          </div>
          }
        </ng-template>
      </p-fileupload>
    </div>

    <ng-template #footer>
      <p-button label="Cancelar" [text]="true" severity="secondary" (onClick)="onCloseUploadFiles()" />
      <p-button label="Guardar" (click)="onSaveFiles()" />
    </ng-template>
  </p-dialog>

  <app-confirmation-dialog [(visible)]="visibleDeleteDialog" type="error" title="Confirmar eliminación"
    message="¿Está seguro de que desea eliminar esta fila? Los cambios solo se aplicarán al guardar."
    confirmButtonText="Eliminar" cancelButtonText="Cancelar" (onConfirm)="confirmDelete()" (onCancel)="cancelDelete()">
  </app-confirmation-dialog>

  <app-confirmation-dialog [(visible)]="visibleConfirmModal" type="warning" title="Cambios sin guardar"
    message="Tiene cambios sin guardar en este formulario. Si continúa, perderá la información ingresada. ¿Desea continuar?"
    confirmButtonText="Continuar" cancelButtonText="Regresar" (onConfirm)="onCloseModal(true)"
    (onCancel)="onCloseModal(false)">
  </app-confirmation-dialog>

</div>
<p-toast />